import type { AustraliaNetPricePricingValues } from "@slfinrtl/ui-bff-routes"
import type { CheckboxFieldProps } from "../../../form/checkbox/CheckboxField"
import type { InputFieldProps } from "../../../form/input/InputField"

export interface AustraliaNetPricePricingFields {
	minimumPrice: InputFieldProps
	netPrice: InputFieldProps
	price: InputFieldProps
	purchasePrice: InputFieldProps
	vatDeductible: CheckboxFieldProps
}

type FieldName = keyof AustraliaNetPricePricingValues

const priceName: FieldName = "price"
const minimumPriceName: FieldName = "minimumPrice"
const purchasePriceName: FieldName = "purchasePrice"
const netPriceName: FieldName = "netPrice"
const vatDeductibleName: FieldName = "vatDeductible"

export const australiaNetPricePricingFieldNames = {
	minimumPriceName,
	netPriceName,
	priceName,
	purchasePriceName,
	vatDeductibleName,
}
